module.exports = __webpack_public_path__ + "assets/img/6607933f72dc595ea61407da0696be4.9e15a791.png";